import parse, {
  domToReact,
  type Element,
  type DOMNode,
} from 'html-react-parser';
import { Heading, Paragraph } from '@hungryroot/ui-kit';
import styles from './Ingredients.module.css';

const THIRD_PARTY_TERMS_ROUTE = '/terms#third-party';
interface IngredientsProps {
  ingredients: string;
  className?: string;
  brandName?: string | null;
}

const replaceBoldAndParagraphTag = (domNode: DOMNode) => {
  if (domNode.type === 'tag') {
    const element = domNode as Element;
    if (element.name === 'b') {
      return (
        <Heading className={styles.section} variant="H6">
          {domToReact(element.children as DOMNode[])}
        </Heading>
      );
    }
    if (element.name === 'p') {
      return (
        <Paragraph className={styles.section}>
          {domToReact(element.children as DOMNode[])}
        </Paragraph>
      );
    }
  }
};

const parseOptions = {
  replace: replaceBoldAndParagraphTag,
};

export function Ingredients(props: IngredientsProps) {
  const { ingredients, className, brandName } = props;

  const effectiveIngredients = parse(ingredients, parseOptions);
  const isHungryrootProduct = brandName === 'Hungryroot';

  return (
    <div className={`${styles.ingredients} ${className}`}>
      <Heading variant="H5">Ingredients</Heading>
      <Paragraph as="div">{effectiveIngredients}</Paragraph>

      {isHungryrootProduct ? null : (
        <Paragraph
          variant="caption"
          testid="third-party-terms"
          className={styles['third-party-terms']}
        >
          <span>Information provided by the brand.</span>{' '}
          <a
            className={styles.link}
            href={THIRD_PARTY_TERMS_ROUTE}
            target="_blank"
          >
            Learn more
          </a>
        </Paragraph>
      )}
    </div>
  );
}
